import type { TGooglePublisherTag } from './types';

export type LoadScriptOptions = {
  eventImpressionViewable?: (
    event: googletag.events.ImpressionViewableEvent,
  ) => void;
};

const initGpt = (options?: LoadScriptOptions) => {
  window.googletag.cmd.push(() => {
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().disableInitialLoad();

    googletag.pubads().setCentering(true);

    if (options?.eventImpressionViewable) {
      googletag
        .pubads()
        .addEventListener(
          'impressionViewable',
          options.eventImpressionViewable,
        );
    }

    googletag.pubads().setTargeting('allowtransparency', '');
    googletag.pubads().enableLazyLoad({
      fetchMarginPercent: 50, // Fetch slots within 50% of the viewport
      renderMarginPercent: 0, // Only render slots when they are in view
      mobileScaling: -1, // No scaling for mobile
    });
    googletag.enableServices();
  });
};

// Using Singleton pattern here to ensure that the script is only loaded once for all ads
let gptScript: Promise<TGooglePublisherTag> | null = null;
export const loadScript = (
  options?: LoadScriptOptions,
): Promise<TGooglePublisherTag> => {
  if (!gptScript) {
    gptScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = 'https://www.googletagservices.com/tag/js/gpt.js';
      script.onload = () => {
        initGpt(options);
        resolve(window.googletag);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return gptScript;
};
